
var $body = $('.js-body'),
    body = document.querySelector('.js-body'),
		//thisPage = $body.attr('data-page'),
		//site = $body.attr('data-site'),
		height = window.innerHeight,
		width = window.innerWidth
;
